var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location on",
    clipPath: "url(#clip0_382_268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00004 1.83325C5.42004 1.83325 3.33337 3.91992 3.33337 6.49992C3.33337 9.99992 8.00004 15.1666 8.00004 15.1666C8.00004 15.1666 12.6667 9.99992 12.6667 6.49992C12.6667 3.91992 10.58 1.83325 8.00004 1.83325ZM8.00004 8.16658C7.08004 8.16658 6.33337 7.41992 6.33337 6.49992C6.33337 5.57992 7.08004 4.83325 8.00004 4.83325C8.92004 4.83325 9.66671 5.57992 9.66671 6.49992C9.66671 7.41992 8.92004 8.16658 8.00004 8.16658Z",
    fill: "#2C3E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.24e22a5ebaf64d45683b5af3925b40ea.svg";
export { ForwardRef as ReactComponent };